<template>
    <v-card>
        <v-card-title>
            Urutan Paket
            <v-spacer></v-spacer>

            <v-progress-circular
                v-if="loading_sequence"
                indeterminate
                color="primary"
                :size="30"
            ></v-progress-circular>

            <v-icon
                v-if="updated_sequence && !loading_sequence"
                color="green"
                style="font-size: 32px"
                >mdi-check-circle</v-icon
            >
        </v-card-title>

        <v-card-subtitle>
            <div>Atur urutan paket dengan drag list paket</div>

            <!-- <div class="mt-5 mb-5">
                <v-btn
                    :color="
                        selected_sort_class === data_kelas
                            ? '#e8f5fa'
                            : '#f3f5f7'
                    "
                    :class="
                        selected_sort_class === data_kelas
                            ? 'blew--text'
                            : 'grey--text'
                    "
                    depressed
                    rounded
                    class="mr-2"
                    v-for="(data_kelas, index) of kelas"
                    :key="index"
                    @click="
                        (selected_sort_class = data_kelas),
                            fetchData(data_kelas)
                    "
                >
                    Kelas {{ data_kelas }}
                </v-btn>
            </div> -->
        </v-card-subtitle>

        <v-card-text width="100%">
            <div class="mt-3 mb-5 pl-4 font-weight-bold">
                <template>
                    <v-row>
                        <v-col cols="2">Nomor Urut</v-col>
                        <v-col cols="8">Nama Paket</v-col>
                    </v-row>
                </template>
            </div>

            <div v-if="isLoading" class="mt-8 text-center">
                <v-progress-circular indeterminate color="blew" />
            </div>

            <div v-if="!isLoading">
                <draggable
                    :list="data"
                    :disabled="!enabled"
                    class="list-group"
                    ghost-class="ghost"
                    @start="dragging = true"
                    @end="finishDragged"
                >
                    <div
                        class="list-group-item pa-6 draggable"
                        v-for="(element, index) in data"
                        :class="element.id == $route.query.id ? 'selected' : ''"
                        :key="element.id"
                    >
                        <v-row>
                            <v-col cols="2" md="2">
                                <v-btn
                                    :color="
                                        element.id == $route.query.id
                                            ? '#29b6f6'
                                            : 'blew'
                                    "
                                    class="font-weight-bold"
                                    style="font-size: 14px"
                                    rounded
                                    fab
                                    x-small
                                    dark
                                    depressed
                                >
                                    {{ index + 1 }}
                                </v-btn>
                            </v-col>
                            <v-col cols="8" md="8" class="pt-1">
                                <div class="font-weight-600">
                                    {{ element.name }}
                                </div>
                                <div>
                                    {{ element.description }}
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="text-center" v-if="!data.length">
                        Paket tidak tersedia
                    </div>
                </draggable>
            </div>
        </v-card-text>

        <v-card-actions class="justify-end">
            <v-btn depressed @click="$emit('close')">Tutup</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import draggable from "vuedraggable";

export default {
    components: {
        draggable,
    },

    data() {
        return {
            isLoading: false,
            loading_sequence: false,
            updated_sequence: false,
            dragging: false,
            enabled: true,
            list_sorted_package: [],
            data: [],
            no_urut: null,
        };
    },

    mounted() {
        this.getAllPackage();
    },

    methods: {
        async getAllPackage() {
            const url = `${process.env.API_BASE_URL}payment/package/getallpackage`;
            this.isLoading = true;

            try {
                const response = await axios.get(url);
                this.data = response.data;

                this.data = _.orderBy(
                    _.filter(this.data, {
                        is_show: 1,
                        package_category: "PACKAGES",
                    }),
                    ["sequence"],
                    ["asc"]
                );
            } catch (err) {
                console.log(err);
            } finally {
                this.isLoading = false;
            }
        },

        finishDragged() {
            this.dragging = false;
            this.list_sorted_package = [];

            this.data.map((res, index) => {
                var no_urut = index + 1;

                this.list_sorted_package.push({
                    id: res.id,
                    sequence: no_urut,
                });

                if (res.id === this.$route.query.id) {
                    this.no_urut = no_urut;
                }
            });

            this.changePackageSequence();
        },

        async changePackageSequence() {
            const context = this;
            const body = context.list_sorted_package;
            const url = `${process.env.API_BASE_URL}payment/package/update/sequence`;

            context.loading_sequence = true;
            context.updated_sequence = false;

            try {
                await axios.put(url, body);
                context.updated_sequence = true;
            } catch (err) {
                console.log(err);
                context.$store.commit("showAlert", {
                    message: `Terjadi kesalahan`,
                    submessage: "Tidak dapat mengubah urutan paket",
                    type: "error",
                });
            } finally {
                context.loading_sequence = false;
            }
        },
    },
};
</script>

<style>
.draggable {
    cursor: all-scroll !important;
}

.selected {
    background-color: #008929;
    color: #fff !important;
}

.ghost {
    opacity: 1;
    background: #ececec;
    cursor: all-scroll !important;
}
</style>



// WEBPACK FOOTER //
// dialogPackageSequence.vue?2c73be8f